import { PencilIcon } from '@heroicons/react/24/outline';
import { Button } from '../button/Button';

export function EditButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Edit ${label}`}
      className="text-onlight-text-2 dark:text-ondark-text-2 dark:hover:bg-ondark-bg-3 hover:bg-onlight-bg-2 shrink-0 rounded p-1"
    >
      <PencilIcon className="h-4 w-4" />
    </button>
  );
}

export function EditActions({
  saving = false,
  onSave,
  onCancel,
}: {
  saving?: boolean;
  onSave: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="mt-3 flex justify-end gap-2">
      <Button
        variant="primary"
        onClick={onSave}
        disabled={saving}
        loading={saving}
      >
        Update
      </Button>
      <Button onClick={onCancel}>Cancel</Button>
    </div>
  );
}
